import type { RefObject } from 'react';
import { fadeFromTo, fadeTo } from 'util/animation/fade/fade';
import type { HeadingRef } from '../../atoms/heading/Heading.data';
import { findTransitionController } from '../../../util/core-transition-component';
import { hideRectangle, revealRectangle } from '../../../util/animation/reveal/reveal';

interface RotateScreenModalRefs {
  phoneRef?: RefObject<HTMLElement | null>;
  elementRef?: RefObject<HTMLElement | null>;
  titleRef?: RefObject<HeadingRef | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,

  { elementRef, titleRef }: RotateScreenModalRefs,
): void {
  if (elementRef?.current) {
    timeline.add(fadeFromTo(elementRef.current as HTMLElement, { duration: 0.01 }));

    timeline.add(
      revealRectangle(elementRef.current as HTMLElement, {
        from: 'top',
        duration: 0.5,
        ease: 'Power2.easeOut',
      }),
      0,
    );
  }

  const title = findTransitionController(titleRef);

  if (title) {
    timeline.add(title?.getTimeline('in') as gsap.core.Timeline, 0.2);
  }
}

export function setupLoopingTimeline(
  timeline: gsap.core.Timeline,
  { phoneRef }: RotateScreenModalRefs,
): void {
  if (phoneRef?.current) {
    timeline
      .to(phoneRef.current, { rotate: -90, duration: 2 })
      .to(phoneRef.current, {
        rotate: -180,
        duration: 0.7,
        ease: 'elastic.out(1.3, 0.75)',
      })
      .repeatDelay(2)
      .repeat(-1);
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef, titleRef }: RotateScreenModalRefs,
): void {
  const title = findTransitionController(titleRef);

  if (title) {
    timeline.add(title?.getTimeline('out') as gsap.core.Timeline, 0);
  }

  if (elementRef?.current) {
    timeline.add(
      hideRectangle(elementRef.current as HTMLElement, {
        to: 'bottom',
        duration: 0.5,
        ease: 'Power2.easeOut',
      }),
      0,
    );

    timeline.add(fadeTo(elementRef.current as HTMLElement, { duration: 0.01 }));
  }
}
